import { createButton, type ClickProps } from './createButton';

export const DismissTextButton = createButton<ClickProps>({
  className: 'text-[12px] text-amber-400/60 transition-colors hover:text-amber-400',
  content: 'Dismiss',
});
